<template>
  <SvgIcon name="loader" class="animate-spin duration-700" :width="size" :height="size"></SvgIcon>
</template>

<script setup lang="ts">
import SvgIcon from '@/components/common/SvgIcon.vue'

defineProps({
  size: { type: Number, default: 24 },
})
</script>
